<template>
    <div class="bg-gray-600 flex flex-col rounded-t-md z-10 navigation-section-bottom-section">
        <slot />
    </div>
</template>

<style scoped>
.navigation-section-bottom-section {
    position: relative;
}

.navigation-section-bottom-section::after {
    position: absolute;
    height: 0.25rem;
    bottom: -0.25rem;
    left: 0;
    right: 0;
    width: 100%;
    background: var(--color-gray-600);
    z-index: 0;
    content: '';
}
</style>
